import gql from 'graphql-tag';
import { TransactionFragment } from '../fragments/transaction.fragment';

export const UPDATE_ONE_TRANSACTION = gql`
    mutation(
        $input: UpdateOneTransactionInput!
    ) {
        updateOneTransaction (
            input: $input
        ) {
            ...TransactionInfo
        }
    }
    ${TransactionFragment}
`;